import React from "react";

import {
  FlexComp,
  ParaTag,
  AnchorTag,
  LandingButton,
  SpanTag,
  CommonModalDweb,
} from "@tm/static";
import { theme } from "@tm/utility/global";

import {
  PaymentFailedModalStyle,
  PaymentFailedNote,
} from "./PaymentFailedModal.style";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";

interface PaymentFailedModalProp {
  title?: string | TextNodeType;
  info?: string | TextNodeType;
  noteTitle?: string | TextNodeType;
  noteInfo?: string | TextNodeType;
  retryBtnTxt?: string;
  backBtnTxt?: string;
  handleRetry?: () => void;
  handleBack?: () => void;
}

const PaymentFailedModal = ({
  title,
  info,
  noteTitle,
  noteInfo,
  retryBtnTxt,
  backBtnTxt,
  handleRetry,
  handleBack,
}: PaymentFailedModalProp) => {
  return (
    <PaymentFailedModalStyle>
      <CommonModalDweb
        errorModal
        handleClick={handleBack}
        customTitle={title}
        customIcon="https://tripmoneycmsimgak.mmtcdn.com/img/caution_Img_09e830be76.svg"
      >
        {info && (
          <ParaTag margin="0 0 10px" fontSize="md" color={theme.greyText}>
            <FormattedText value={info} />
          </ParaTag>
        )}

        <PaymentFailedNote>
          {noteTitle && (
            <SpanTag fontWeight="bold" fontSize="large">
              <FormattedText value={noteTitle} />
            </SpanTag>
          )}

          {noteInfo && (
            <ParaTag>
              <FormattedText value={noteInfo} />
            </ParaTag>
          )}
        </PaymentFailedNote>

        <FlexComp justifyContent="space-between" alignItems="center" gap="10px">
          <LandingButton
            customWidth="fit-content"
            customTitle={retryBtnTxt}
            onClick={handleRetry}
          />
          <AnchorTag textTransform="uppercase" fontSize="md" fontWeight="bold">
            <FormattedText value={backBtnTxt} />
          </AnchorTag>
        </FlexComp>
      </CommonModalDweb>
    </PaymentFailedModalStyle>
  );
};

export default PaymentFailedModal;
